import * as constants from "@/constants";
import environments from "@/environments";
import {
  CopyMarkProps,
  CreateMarkProps,
  DeleteMarkProps,
  UpdateMarkCoordinatesProps,
  UpdateMarkProps,
} from "@/sx-layout/components/plotmap/actions/types";
import { stripHashFromHexColor } from "@/sx-layout/utils";

export const createMark = (props: CreateMarkProps, callback?: (res) => void, fallback?: () => void) => {
  const endpoint = `${environments.API_BASE_URI}/marks/create`;
  const request = JSON.stringify({
    ...props,
    color: props.color?.replace("#", ""),
  });

  return {
    type: constants.APP_CALL_API,
    endpoint,
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    body: request,
    callbacks: {
      begin: () => {
        return {
          type: constants.MARK_BEGIN_CREATE_MARK,
        };
      },
      success: (response) => {
        callback?.(response);

        return {
          type: constants.MARK_END_CREATE_MARK,
          payload: response,
        };
      },
      error: (response) => {
        fallback?.();

        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};

export const updateMark = (props: UpdateMarkProps, callback?: (res) => void, fallback?: () => void) => {
  const endpoint = `${environments.API_BASE_URI}/marks/update/${props.mark_id}`;

  const request = JSON.stringify({
    ...props,
    color: stripHashFromHexColor(props.color),
  });

  return {
    type: constants.APP_CALL_API,
    endpoint,
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    body: request,
    callbacks: {
      begin: () => {
        return {
          type: constants.MARK_BEGIN_UPDATE_MARK,
        };
      },
      success: (response) => {
        callback?.(response);

        return {
          type: constants.MARK_END_UPDATE_MARK,
          payload: response,
        };
      },
      error: (response) => {
        fallback?.();

        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};

export const copyMark = (props: CopyMarkProps, callback?: (res) => void, fallback?: () => void) => {
  const endpoint = `${environments.API_BASE_URI}/marks/copy`;

  return {
    type: constants.APP_CALL_API,
    endpoint,
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    body: JSON.stringify(props),
    callbacks: {
      begin: () => {
        return {
          type: constants.MARK_BEGIN_COPY_MARK,
        };
      },
      success: (response) => {
        callback?.(response);

        return {
          type: constants.MARK_END_COPY_MARK,
          payload: response.marks,
        };
      },
      error: (response) => {
        fallback?.();

        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};

export const deleteMark = (props: DeleteMarkProps, callback?: (res) => void, fallback?: () => void) => {
  const endpoint = `${environments.API_BASE_URI}/marks/delete/${props.mark_id}`;

  return {
    type: constants.APP_CALL_API,
    endpoint,
    method: "POST",
    body: JSON.stringify({ timestamp: props.timestamp }),
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    callbacks: {
      begin: () => {
        return {
          type: constants.MARK_BEGIN_DELETE_MARK,
        };
      },
      success: (response) => {
        callback?.(response);

        return {
          type: constants.MARK_END_DELETE_MARK,
          payload: {
            ...response,
            mark_id: props.mark_id,
          },
        };
      },
      error: (response) => {
        fallback?.();

        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};

export const updateMarkCoordinates = (
  props: UpdateMarkCoordinatesProps,
  callback?: (res) => void,
  fallback?: () => void
) => {
  const endpoint = `${environments.API_BASE_URI}/marks/coord/update/${props.mark_id}`;

  return {
    type: constants.APP_CALL_API,
    endpoint,
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    body: JSON.stringify(props),
    callbacks: {
      begin: () => {
        return {
          type: constants.MARK_BEGIN_UPDATE_MARK_COORDINATES,
        };
      },
      success: (response) => {
        callback?.(response);

        return {
          type: constants.MARK_END_UPDATE_MARK_COORDINATES,
          params: props,
          payload: response,
        };
      },
      error: (response) => {
        fallback?.();

        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};
